/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Image_Export_Status_Exporting_ImageInputs */

const en_image_export_status_exporting_image = /** @type {(inputs: Image_Export_Status_Exporting_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exporting image ${i?.current} of ${i?.total}...`)
};

const fr_image_export_status_exporting_image = /** @type {(inputs: Image_Export_Status_Exporting_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportation de l'image ${i?.current} sur ${i?.total}...`)
};

const de_image_export_status_exporting_image = /** @type {(inputs: Image_Export_Status_Exporting_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportiere Bild ${i?.current} von ${i?.total}...`)
};

const it_image_export_status_exporting_image = /** @type {(inputs: Image_Export_Status_Exporting_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportazione dell'immagine ${i?.current} di ${i?.total}...`)
};

const ru_image_export_status_exporting_image = /** @type {(inputs: Image_Export_Status_Exporting_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Экспорт изображения ${i?.current} изображения ${i?.total}...`)
};

const es_image_export_status_exporting_image = /** @type {(inputs: Image_Export_Status_Exporting_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando imagen ${i?.current} de ${i?.total}...`)
};

const zh_cn2_image_export_status_exporting_image = /** @type {(inputs: Image_Export_Status_Exporting_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在导出 ${i?.total} 的图像 ${i?.current}...`)
};

const ja_image_export_status_exporting_image = /** @type {(inputs: Image_Export_Status_Exporting_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`画像 ${i?.current} / ${i?.total} をエクスポートしています...`)
};

const hi_image_export_status_exporting_image = /** @type {(inputs: Image_Export_Status_Exporting_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} की छवि ${i?.current} निर्यात की जा रही है...`)
};

const pt_pt2_image_export_status_exporting_image = /** @type {(inputs: Image_Export_Status_Exporting_ImageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando imagem ${i?.current} de ${i?.total}...`)
};

/**
* | output |
* | --- |
* | "Exporting image {current} of {total}..." |
*
* @param {Image_Export_Status_Exporting_ImageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_status_exporting_image = /** @type {((inputs: Image_Export_Status_Exporting_ImageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Status_Exporting_ImageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_status_exporting_image(inputs)
	if (locale === "de") return de_image_export_status_exporting_image(inputs)
	if (locale === "it") return it_image_export_status_exporting_image(inputs)
	if (locale === "ru") return ru_image_export_status_exporting_image(inputs)
	if (locale === "es") return es_image_export_status_exporting_image(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_status_exporting_image(inputs)
	if (locale === "ja") return ja_image_export_status_exporting_image(inputs)
	if (locale === "hi") return hi_image_export_status_exporting_image(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_status_exporting_image(inputs)
	return en_image_export_status_exporting_image(inputs)
});